import { PAY_DURING_COLLECTION_MODE, CONSUMER_WEB_PLATFORM } from "@/utils/constants";
import { OrderReducer } from "@/utils/interfaces";
import { createSlice } from "@reduxjs/toolkit";


const initAddressDto = {
  addressType: '',
  city: '',
  area: '',
  cityUuid: '',
  areaUuid: '',
  pincode: '',
  locality: null,
  latitude: 0,
  longitude: 0,
  landmark: null,
  state: null,
  country: null,
}

const initPaymentDto = {
  amountPending: 0,
  homeCollectionCharges: 0,
  hcConfigCode: '',
  numberOfVisits: 0,
  numberOfFreeVisits: 0,
  perVisitCharge: 0,
  paid: false,
  reportHomeDeliveryCharges: 0,
  testCharges: 0,
  couponDiscountAmount: 0,
  clubAgilusAmount: 0,
  nonDiscountTestCharges: 0,
  totalAmount: 0,
}

const initHCDto = {
  applied: false,
  waiveOffReason: '',
  waiveOffReasonUuid: '',
  waiveOffReasonId: null,
}
export const initCouponDto = {
  applied: false,
  amountSaved: 0,
}

const initLoyaltyDto = {
  applied: false,
  redeemedAmount: 0,
  redeemablePoints: 0,
  loyaltyReedemablePoints: 0,
  availablePoints: 0,
  loyaltyAllowedWithCoupon: true,
}
export const initSavingDto = {
  couponDetailResponseDto: initCouponDto,
  loyaltyDto: initLoyaltyDto,
}

const initVisitDto = {
  fromTime: '',
  toTime: '',
  visitCharge: 0,
}
const orderInitialState: OrderReducer = {
  cartDtoList: [],
  addressDto: initAddressDto,
  appointmentTimeDtoList: [],
  paymentDetailDto: initPaymentDto,
  homeCollectionChargesDto: initHCDto,
  savingDto: initSavingDto,
  visitDetailDto: initVisitDto,
  orderSource: CONSUMER_WEB_PLATFORM,
  action: 'INSERT',
  orderResponse: {},
  patientDtoList: [],
  checkoutOptionList: [],
  paymentMode: PAY_DURING_COLLECTION_MODE,
}

const orderSlice = createSlice({
  name: 'orderReducer',
  initialState: orderInitialState,
  reducers: {
    updateOrderData: (state, action) => {
      return { ...state, ...action.payload }
    },
    resetOrderData: () => {
      return orderInitialState
    },
  },
})
export const { updateOrderData, resetOrderData } = orderSlice.actions
export default orderSlice.reducer
